function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), React.createElement("path", {
  d: "M1.02 6A1 1 0 01.5 4.134C.82 3.95 3.32 2.572 8 0c4.681 2.572 7.181 3.95 7.5 4.134A1 1 0 0114.98 6zM11 14V7.5h3V14h1a1 1 0 011 1v1H0v-1a1 1 0 011-1h1V7.5h3V14h1.5V7.5h3V14z",
  fillRule: "evenodd"
})));